module.exports = __webpack_public_path__ + "images/social-icons/email-icon.a95d1e43be44f6f8e745.svg";